import Modal from "@/components/modals/modal/modal.vue";
import emitHideMixin from '@/components/modals/mixins/emit-hide'
import {mapActions, mapState} from "vuex";

export default {
    name: 'LostConnectionsModal',
    /**
     * emitHideMixin - методы hide и onHideModal
     */
    mixins: [emitHideMixin],
    components: {
        Modal
    },
    computed: {
        ...mapState({
            collectOrders: state => state.collectOrders
        }),
    },
    methods: {
        ...mapActions({
            closeSocketConnections: 'collectOrders/closeSocketConnections',
            setCollectConnection :'collectOrders/setCollectConnection',
            setRemakeConnection: 'collectOrders/setRemakeConnection',
        }),
        show() {
            this.closeSocketConnections()
            this.$refs.modal.show()
        },
        async close() {
            try {
                await Promise.all([
                    this.setRemakeConnection(),
                    this.setCollectConnection(),
                ])
            } finally {
                this.hide()
            }
        },
    },
}